import { __assign, __rest } from "tslib";
import React, { useState } from 'react';
import { MaskRange } from '../../facades/MaskedInput';
import { MaskedInput } from '../../facades';
export var AsureCloudDateInput = function (_a) {
    var invalidDateMessage = _a.invalidDateMessage, onUpdate = _a.onUpdate, label = _a.label, fromYear = _a.fromYear, toYear = _a.toYear, props = __rest(_a, ["invalidDateMessage", "onUpdate", "label", "fromYear", "toYear"]);
    var _b = useState(false), isInvalid = _b[0], setInvalid = _b[1];
    var _c = useState(), maskedRef = _c[0], setMaskedRef = _c[1];
    var isLeapYear = function (year) {
        return year % 100 === 0 ? year % 400 === 0 : year % 4 === 0;
    };
    var onInputUpdate = function (mask) {
        var _a;
        setMaskedRef(mask.el.input);
        var dateArray = mask.value.split('/');
        var month = dateArray[0] || undefined;
        var day = dateArray[1] || undefined;
        var year = dateArray[2] || undefined;
        var thirtyOneMonths = ['01', '03', '05', '07', '08', '10', '12'];
        var leapYear = isLeapYear(year);
        var isDirty = false;
        if (thirtyOneMonths.indexOf(month) === -1 && day === '31') {
            day = 30;
            isDirty = true;
        }
        if (((_a = year) === null || _a === void 0 ? void 0 : _a.length) === 4 && month === '02' && day > 28) {
            if (leapYear && day >= 29) {
                day = 29;
                isDirty = true;
            }
            else {
                day = 28;
                isDirty = true;
            }
        }
        if (isDirty) {
            mask.value = [month, day, year].filter(Boolean).join('/');
        }
        onUpdate(mask.value);
    };
    var onBlur = function (event) {
        event.stopPropagation();
        if (event.target.value.length !== 10) {
            maskedRef.setCustomValidity(invalidDateMessage);
            setInvalid(true);
        }
    };
    var clearInvalid = function () {
        if (maskedRef !== undefined) {
            maskedRef.setCustomValidity('');
        }
        isInvalid && setInvalid(false);
    };
    return (React.createElement("div", { className: "d-flex flex-column-reverse" },
        React.createElement(MaskedInput, __assign({}, props, { mask: Date, pattern: "m/`d/`Y", placeholder: "mm/dd/yyyy", autofix: true, unmask: false, overwrite: true, className: "" + (props.className ? props.className : '') + (isInvalid ? ' invalid' : '') + " p-2", blocks: {
                d: {
                    mask: MaskRange,
                    from: 1,
                    to: 31,
                    maxLength: 2,
                },
                m: {
                    mask: MaskRange,
                    from: 1,
                    to: 12,
                    maxLength: 2,
                },
                Y: {
                    mask: MaskRange,
                    from: fromYear,
                    to: toYear,
                },
            }, format: function (date) {
                var day = date.getDate();
                var month = date.getMonth() + 1;
                var year = date.getFullYear();
                if (day < 10)
                    day = '0' + day;
                if (month < 10)
                    month = '0' + month;
                var returnDate = [month, day, year].join('/');
                return returnDate;
            }, parse: function (str) {
                return new Date(str);
            }, onAccept: function (value, mask) { return onInputUpdate(mask); }, onBlur: onBlur, onInvalidCapture: function () { return setInvalid(true); }, onInput: clearInvalid })),
        React.createElement("label", { className: "mb-2 d-flex flex-row flex-nowrap" }, label)));
};
export default AsureCloudDateInput;
AsureCloudDateInput.defaultProps = {
    invalidDateMessage: "Invalid date. Please check the date and reenter.",
    fromYear: 1900,
    toYear: 9999,
};
//# sourceMappingURL=DateInput.js.map